import { Dictionary, omitBy } from 'lodash';
import { createSelector } from 'reselect';

import { UDRsPolyAssetGroup } from '@common-modules/mediaDetails/models';
import { selectStore } from './view';

export const selectMediaDataUrl = createSelector(
  selectStore,
  (s) => s.mediaDataUrl
);

export const selectMediaDataContainerId = createSelector(
  selectStore,
  (s) => s.mediaDataContainerId
);

// VMASKTODO this seems like the wrong file
export const selectVoiceMaskMediaUrl = createSelector(
  selectStore,
  (s) => s.voiceMaskMediaUrl
);

export const selectHasSavedUdrs = createSelector(
  selectStore,
  (s) => s.hasSavedUdrs
);

export const selectLastSaveMediaDataDisplayTime = createSelector(
  selectStore,
  (s) => s.lastSaveMediaDataDisplayTime
);

export const selectUdrAsset = createSelector(selectStore, (s) => s.udrAsset);
export const selectLastSprayPaintSeriesItemId = createSelector(
  selectStore,
  (s) => s.udrAsset.lastSprayPaintSeriesItemId
);

export const selectLastUdrGroupsWithUpdatedClusterAssignment = createSelector(
  selectStore,
  (s) => s.lastUdrGroupsWithUpdatedClusterAssignment
);

export const selectNewSprayPaintEditId = createSelector(
  selectStore,
  (s) => s.newSprayPaintEditId
);
export const selectUdrAssetNotNil = createSelector(selectUdrAsset, (s) => ({
  boundingPolys: omitBy(
    s.boundingPolys,
    (u) => u === null
  ) as Dictionary<UDRsPolyAssetGroup>,
}));
